export default {
  selectorWrapper: {
    marginBottom: 7
  }
}
